﻿import './productDetail.less'
import FAQs from '../components/faq';

const init = () => {

    const faqSetup = new FAQs();
    const buyNowBtn = document.querySelector("#destiniBuy");

    var containerId = "destiniModal";
    //if (buyNowBtn) {
    //    var associationId = `&APOG=${buyNowBtn.dataset.gtin}`;
    //    destini.init(containerId);
    //    destini.loadWidget(associationId);

    //}

    PepNutritionLabel.init();

    document.querySelectorAll("a.option-select-box").forEach((item) => {
        item.addEventListener("click", (e) => {

            sessionStorage.setItem('scrollProductPosition', window.scrollY);

        });
    });

    if (sessionStorage.getItem("scrollProductPosition")) {
        window.scrollTo(0, parseInt(sessionStorage.getItem("scrollProductPosition")));
        sessionStorage.removeItem('scrollProductPosition');
    }

    const flavorOver = (thisItem) => {
        document.querySelector(".newFlavorText").innerHTML = thisItem.dataset.flavor;
        document.querySelector("#newFlavor").style.display = "block";
        document.querySelector("#currentFlavor").style.display = "none";
    }

    const flavorOut = (thisItem) => {
        document.querySelector(".newFlavorText").innerHTML = "";
        document.querySelector("#newFlavor").style.display = "none";
        document.querySelector("#currentFlavor").style.display = "block";
    }

    if (document.querySelectorAll(".flavor-box")) {
        document.querySelectorAll(".flavor-box").forEach((item) => {
            item.addEventListener("focus", (e) => {
                const thisItem = e.currentTarget;
                flavorOver(thisItem);
                
            });
            item.addEventListener("blur", (e) => {
                const thisItem = e.currentTarget;
                flavorOut(thisItem);
                
            });
            item.addEventListener("mouseenter", (e) => {
                const thisItem = e.currentTarget;
                flavorOver(thisItem);
                
            });
            item.addEventListener("mouseleave", (e) => {
                const thisItem = e.currentTarget;
                flavorOut(thisItem);
                
            });
        });
    }

    //const panel = document.querySelector("#sub-thirds");
    //if (panel) {
    //    thirdsPanel();
    //}

}

const thirdsPanel = () => {
    gsap.registerPlugin( Observer, ScrollTrigger, ScrollSmoother, ScrollToPlugin)

    ScrollTrigger.defaults({
        markers: false
    });

    if (window.innerWidth >= 768) {
        const thirds = gsap.timeline({
            scrollTrigger: {
                trigger: "#sub-thirds",
                start: "top 100px",
                end: "200%",
                pin: true,
                scrub: true,
                invalidateOnRefresh: true,
                markers: false
            }
        }).to("#sub-thirds .sub-third-one", { duration: 1, width: "50vw" })
            .to("#sub-thirds .sub-third-one div", { duration: 1, x: "-26vw" }, "0")
            .to("#sub-thirds .sub-third-two", { duration: 1, x: "-50vw" }, "0")
            .to("#sub-thirds .sub-third-one", { duration: 1, width: "33.34vw" }, "1.5")
            .to("#sub-thirds .sub-third-one div", { duration: 1, x: "-61vw" }, "1.5")
            .to("#sub-thirds .sub-third-two", { duration: 1, x: "-66.7vw" }, "1.5")
            .to("#sub-thirds .sub-third-three", { duration: 1, x: "-33.33vw" }, "1.5")
            .to(null, { duration: 1 })

    } else {
        const thirds = gsap.timeline({
            scrollTrigger: {
                trigger: "#sub-thirds",
                start: "top 100px",
                end: "200%",
                pin: true,
                scrub: true,
                invalidateOnRefresh: true,
                markers: false
            }
        }).to("#sub-thirds .sub-third-one", { duration: 1, width: "100vw" })
           
            .to("#sub-thirds .sub-third-two", { duration: 1, x: "-100vw" }, "1.5")

            .to("#sub-thirds .sub-third-three", { duration: 1, x: "-100vw" }, "3")
            .to(null, { duration: 1 })
    }

    const color = document.querySelector("#sub-thirds").dataset.color;
    
    switch (color) {
        case "purple":
            document.querySelector(".pin-spacer").style.backgroundColor = "#b7a6cf";
            break;
        case "blue":
            document.querySelector(".pin-spacer").style.backgroundColor = "#70C5E7";
            break;
        case "tan":
            document.querySelector(".pin-spacer").style.backgroundColor = "#DDB695";
            break;
        case "brown":
            document.querySelector(".pin-spacer").style.backgroundColor = "#8D6C52";
            break;
    }

}


//window.addEventListener("pageswap", async (e) => {
//    if (e.viewTransition) {
//        const transitionType = determineTransitionType(e.activation.from, e.activation.entry);
//        e.viewTransition.types.add(transitionType);

//        if (!window.navigation) {
//            localStorage.setItem("transitionType", transitionType);
//        }
//    }
//});

//window.addEventListener("pagereveal", async (e) => {
//    if (e.viewTransition) {
//        let transitionType;
//        if (!window.navigation) {
//            transitionType = localStorage.getItem("transitionType");
//        } else {
//            transitionType = determineTransitionType(navigation.activation.from, navigation.activation.entry);
//        }

//        e.viewTransition.types.add(transitionType);
//    }
//});

//const determineTransitionType = (oldNavigationEntry, newNavigationEntry) => {
//    if (!oldNavigationEntry || !newNavigationEntry) {
//        return 'unknown';
//    }
//    const basePath = "";
//    const currentURL = new URL(oldNavigationEntry.url);
//    const destinationURL = new URL(newNavigationEntry.url);

//    const currentPathname = currentURL.pathname.replace(basePath, '');
//    const destinationPathname = destinationURL.pathname.replace(basePath, '');

//    if (currentPathname === destinationPathname) {
//        return "reload";
//    } else {
//        //let currentPageIndex = currentPathname.replace('/index', '').replace('/', '').replace('.html', '');
//        //let destinationPageIndex = destinationPathname.replace('/index', '').replace('/', '').replace('.html', '');

//        //// The first page has no number in its path
//        //currentPageIndex = currentPageIndex ? parseInt(currentPageIndex) : 1;
//        //destinationPageIndex = destinationPageIndex ? parseInt(destinationPageIndex) : 1;

//        //if (currentPageIndex > destinationPageIndex) {
//        //    return 'backwards';
//        //}
//        //if (currentPageIndex < destinationPageIndex) {
//        //    return 'forwards';
//        //}

//        return 'forwards';

//        return 'unknown';
//    }
//}

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        init();
    });
}
